function RiverData(data) {

  this.getProfile = function(i)
  {
    return data.elements[i].profile;
  }

  this.getMonthsCount = function()
  {
    return data.months.length;
  };

  this.getMonth = function(i)
  {
    return data.months[i];
  };

  this.getElementsNumber = function()
  {
    return data.elements.length;
  };

  this.getElementNames = function()
  {
    return data.elements.map(function(artist) { return artist.name });
  };

  this.getElement = function(i)
  {
    return data.elements[i];
  };

  this.getElementPosition = function(monthIndex, elementIndex, subIndex)
  {
    return data.elements[elementIndex].position[monthIndex*2 + subIndex];
  };

  this.getElementColor = function(i)
  { 
    return data.elements[i].color;
  };

}

module.exports = RiverData


// WEBPACK FOOTER //
// ./src/js/models/RiverData.js